/**
 * Segmento de caminho do Handlebars — `{{ trigger.<segmento>.0.value }}`.
 *
 * A regra anterior era a de identificador JavaScript, que recusa qualquer
 * caractere fora de `[a-zA-Z0-9_$]`: nome com acento virava segmento literal
 * (`{{ trigger.[Número] }}`) sem precisar. O lexer do Handlebars é bem mais
 * permissivo — ele recusa só o conjunto abaixo, então letra acentuada, dígito,
 * `-`, `_`, `$`, `:` e `?` entram direto no caminho.
 *
 * Três exceções que não estão no conjunto:
 * - `this` é palavra reservada do Handlebars e quebra a compilação;
 * - nome com `]` não tem representação nenhuma: o `]` fecha o segmento literal
 *   e a barra invertida não é escape para o lexer. Sai como `[Campo]x]`, que
 *   não compila — não há forma de referenciar esse campo em Handlebars, e a
 *   alternativa é renomear o campo ou usar um passo de script.
 * - nome com `\` é pior que o `]`: `[A\B]` compila e resolve vazio, sem erro
 *   nenhum. A barra invertida escapa o `]` que fecharia o segmento. Mesma
 *   saída — renomear o campo.
 *
 * `/` é o caso traiçoeiro do conjunto: sem colchetes ele não dá erro de
 * compilação, o caminho só resolve vazio em silêncio. Com colchetes funciona,
 * então só aparece para quem digita a anotação à mão.
 */
const UNSAFE_IN_SEGMENT = /[\s!"#%&'()*+,./;<=>@[\\\]^`{|}~]/;

export const needsHandlebarsBrackets = (name) => {
    const value = String(name ?? "");
    return value === "" || value === "this" || UNSAFE_IN_SEGMENT.test(value);
};

/** O nome do campo pronto para entrar num caminho de template. */
export const toHandlebarsSegment = (name) => {
    const value = String(name ?? "");
    return needsHandlebarsBrackets(value) ? `[${value}]` : value;
};
